'use client';

import { ReactNode, Suspense, useRef, useState } from 'react';

import { UpgradeAndConsentFlow } from '@components/UpgradeAndConsentDialog/V2/AppRouterUpgradeAndConsentFlow';

import { UpgradeAndConsentDialog } from '@components/UpgradeAndConsentDialog/V2/UpgradeAndConsentDialog';
import { useActorPlan } from '@hooks/actor/use-actor-plan';

import { CurrentModalState, ModalType } from './types';
import { GlobalModalContext } from './contexts';

/**
 * Provider component for the GlobalModal context.
 */
export const GlobalModalProvider = ({ children }: { children: ReactNode }) => {
  useActorPlan();
  const [currentModal, setCurrentModal] = useState<CurrentModalState | null>(null);
  const registeredModals = useRef<Set<ModalType>>(new Set());

  const registerModals = (newModals: ModalType[]) => {
    newModals.forEach((modal) => {
      registeredModals.current.add(modal);
    });
  };

  return (
    <Suspense fallback={children}>
      <GlobalModalContext.Provider
        value={{
          currentModal: currentModal?.type || null,
          registerModals,
          openModal: setCurrentModal,
          closeModal: () => {
            console;
            setCurrentModal(null);
          },
        }}
      >
        {children}
        <div>
          {registeredModals.current.has(ModalType.UPGRADE) && (
            <UpgradeAndConsentDialog
              type={'upgrade'}
              show={currentModal?.type === ModalType.UPGRADE}
              trackingSource={currentModal?.trackingSource}
              onClose={() => setCurrentModal(null)}
            />
          )}
          {/* Auto opening dialog, does not render itself unless needed */}
          <UpgradeAndConsentFlow />
        </div>
      </GlobalModalContext.Provider>
    </Suspense>
  );
};
